import React from "react";
import { useAuth } from "@/context/AuthContext";

// Dynamic per-partner attribution. Only renders on co-branded (non-fisbo) tenants.
export default function PoweredBy({ className = "" }) {
  const { tenant } = useAuth();
  if (!tenant?.slug || tenant.slug === "fisbo" || !tenant?.name) return null;
  return (
    <p className={`text-xs italic text-neutral-400 ${className}`} data-testid="powered-by">
      Powered by {tenant.name}
    </p>
  );
}
